import { render, staticRenderFns } from "./side.bar.html?vue&type=template&id=88e07e1e&external"
import script from "./side.bar.vue?vue&type=script&lang=js"
export * from "./side.bar.vue?vue&type=script&lang=js"
import style0 from "@/shared/global.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./side.bar.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports